import { render } from "./DuplicateBox.vue?vue&type=template&id=0d646c8e&scoped=true"
import script from "./DuplicateBox.vue?vue&type=script&lang=js"
export * from "./DuplicateBox.vue?vue&type=script&lang=js"

import "./DuplicateBox.vue?vue&type=style&index=0&id=0d646c8e&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d646c8e"]])

export default __exports__